import { Description, Title, TitleWrapper, Wrapper } from './EmptyProblemReportContent.styles';

interface Props {
  title: string;
  description: string;
  emoji: string;
}

export const EmptyProblemReportContent: React.FC<Props> = ({ title, description, emoji }) => {
  return (
    <Wrapper>
      <span role="img" aria-label="Empty problem report">
        {emoji}
      </span>
      <TitleWrapper>
        <Title>{title}</Title>
        <Description>{description}</Description>
      </TitleWrapper>
    </Wrapper>
  );
};
